import { SubmissionError } from 'redux-form';
import { camelCase } from 'lodash'

// setDeep converts an object with a dot noted key to a deeper object on that 
// dot noted key
function setDeep(obj, path, value) {
  const keys = path.split(".")
  let current = obj

  keys.forEach((rawKey, idx) => {
    const key = camelCase(rawKey)

    if (idx === keys.length - 1) {
      // final key → assign value
      current[key] = value
    } else {
      // intermediate key → ensure object exists
      if (typeof current[key] !== "object" || current[key] === null) {
        current[key] = {}
      }
      current = current[key]
    }
  })

  return obj
}

// normalize runs through the object to nest/object dot noted attributes for
// react form
function normalize(obj) {
  const result = {}
  const keys = Object.keys(obj)

  let i = 0
  const j = keys.length
  for (; i < j; i++) {
    const key = keys[i]

    setDeep(result, key, obj[key])
  }

  return result
}

/**
 * handleSubmissionErrors processes submission (form action) errors and throw
 * them in a way that redux and redux-form can render them
 *
 * @param {Object} payload (json payload returned from server, should contain errors)
 * @param {String} message (override the _error message)
 * @return {SubmissionError}
 * @api public
 */

const handleSubmissionErrors = (payload, message) => {
  // this is the error object in the payload[ payload
  const { error } = payload

  // "ValidationError"s should always come in as a "fields" attribute. Otherwise
  // it should would be a generic error. Just throw it's message
  if (!('fields' in error)) {
    throw new SubmissionError({ _error: error.message })
  }

  // Process ValidationErrors so they can be rendered inline to their form 
  // fields
  let fieldErrors = {}
  const keys = Object.keys(error.fields)
  
  let i = 0;
  const j = keys.length
  for (; i < j; i++) {
    const attr = keys[0]
    const errs = error.fields[attr].join(', ') // submission errors, most likely 
                                               // Sequelize validation errors 
                                               // error will always be returned 
                                               // as an array

    fieldErrors = { ...fieldErrors, ...normalize({[attr]: errs}) }
  }
  if (Object.keys(fieldErrors).length > 0) {
    throw new SubmissionError({
      ...fieldErrors, 
      _error: message || 'There was a problem submitting your request'
    })
  }

  // technically this should never be hit, but calling handleSubmissionErrors
  // should always throw
  throw new SubmissionError({ _error: `${message || 'Something went wrong'} (h)` })
}


/**
 * expose
 */

export { handleSubmissionErrors }
